import { createI18n } from 'vue-i18n'

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
/*function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
}*/

const htmlEl = document.documentElement.lang;

export default createI18n({
  legacy: false,
  locale: htmlEl,
  fallbackLocale:'nl',
  messages: {
    nl: {
      "intro":"U wilt graag een huis-aan-huis campagne lanceren? Hieronder kan u een inschatting maken van het budget. Geef hieronder al uw gegevens door en wij bezorgen u zo snel mogelijk een offerte op maat.",
      "loader":"Uw bericht wordt verzonden",
      "form":{
        "firstFieldset":{
          "title" : "1. Specificaties van je drukwerk",
          "labelGewichtFolder":"Gewicht per folder",
          "ofLabel":"of",
          "labelGrammagePapier":"Grammage van het papier",
          "aantalVellen":"Aantal vellen per folder",
          "labelAfmetingFolder":"Afmetingen van de folder",
          "labelDistributieWeek":"Distributieweek",
          "toolTipDistributieWeek":"Uw drukwerk kan ten vroegste binnen 2 weken bedeeld worden.",
          "weekMessage":"Uw drukwerk maakt standaard deel uit van het folderpakket. Consumenten ontvangen dit tussen zondagochtend en dinsdagavond. Indien u creatief drukwerk wilt laten bedelen (zoals een deurhanger, sample, …), gelieve dan contact op te nemen met",
          "summerMessage":"In de maanden juli en augustus gaat er een aangepaste zomerregeling van start. Wat houdt dit in? In een zeer beperkt aantal gebieden is er een wijziging in de frequentie van de bedeling van het folderpakket. U kan via deze simulator uw aanvraag invoeren en onze customer service zal u spoedig informeren of de aangepaste zomerregeling invloed heeft op uw gekozen zone. Hier vindt u een overzicht van de planning.",
          "summerMessageLabel":"Aangepaste zomerregeling",
          "summerMessagePart2":"vindt u een overzicht van de planning.",
          "summerMessageHier": "Hier",
          "summerMessageLink": "https://www.bdmedia.be/sites/bdmedia.be/files/2023-06/Zomerregeling_0.pdf"
        },
        "secondFieldset":{
          "title":"2. Selecteer de zone waarin u uw drukwerk wilt verdelen",
          "intro":"Voeg hier de postcode(s),(deel)gemeente(s),provincie(s) of regio(s) in waar je jouw drukwerk wenst te bedelen, of maak jouw selectie op de kaart",
          "buttonToevoegen":"Toevoegen",
          "labelSelectie":"Uw selectie",
          "foutmeldingSearch":"U moet een waarde kiezen uit de voorgestelde opties.",
          "labelPrice":"Indicatie van het budget",
          "foutmeldingSearchInput":"Gelieve een zoekwaarde in te geven a.u.b.",
          "toolTipTaal":"Hieronder vindt u de taal waarin u uw drukwerk dient aan te leveren.",
          "toolTipAantal":"Totaal aantal te verdelen commercieel drukwerk in uw selectie (netto aantallen).",
          "brutoAantallen":"Totaal aantal brievenbussen in uw selectie (bruto aantallen).",
          "nettoAantallen":"Totaal aantal te verdelen commercieel drukwerk in uw selectie (netto aantallen).",
          "labelTaal":"Taal",
          "labelAantal":"Aantal",
          "labelGemeente":"Gemeente",
          "labelDeelgemeente":"Deelgemeente",
          "labelProvincie":"Provincie",
          "labelProvincies":"Provincies",
          "distriMessage1":'<div class="message-inner"><h3>Opgelet!</h3>In deze distributieweek wordt een deel van uw gekozen gebieden niet bedeeld en geldt er een minstens tweewekelijkse bedeling. Kies hierboven een andere distributieweek indien u deze zone wenst te bedelen.</div>',
          "distriMessage2":'<div class="message-inner"><h3>Opgelet!</h3>Uw gekozen gebieden worden niet meer bedeeld.</div>',
          "distriMessage3":'<div class="message-inner"><h3>Opgelet!</h3>Een deel van uw gekozen gebieden wordt niet meer bedeeld.</div>',
          "distriMessage4":'<div class="message-inner"><h3>Opgelet!</h3>In een deel van uw gekozen gebieden wordt niet meer of niet meer wekelijks bedeeld. Kies hierboven een andere distributieweek indien u een deel van de zones toch wenst te bedelen of selecteer een ander gebied.</div>',
        },
        "thirdFieldset":{
          "title":"3. Offerte aanvragen bij BD MEDIA",
          "onderwerp":"Geef hier kort het onderwerp door van het te bedelen drukwerk.",
          "placeholderDescription":"vb: Folder met promoties op electronische toestellen 01/01/2022",
          "labelOnderwerp":"Onderwerp van de folder",
          "labelGegevens":"Uw gegevens",
          "labelBedrijfsnaam":"Bedrijfsnaam",
          "labelVenootschapsvorm":"Vennootschapsvorm",
          "labelVat":"BTW-nummer",
          "labelStraat":"Straat",
          "labelNummer":"Nummer",
          "labelBus":"Bus",
          "labelPostcode":"Postcode",
          "labelGemeente":"Gemeente",
          "labelLand":"Land",
          "labelVoornaam":"Voornaam",
          "labelAchternaam":"Achternaam",
          "labelEmail":"E-mailadres",
          "labelTelefoon":"Telefoonnnummer",
          "labelReferentie":"Referentie klantennummer",
          "labelOpmerkingen":"Opmerkingen",
          "labelProvincie":"Provincie",
          "labelProvincies":"Provincies",
          "labelDeelgemeente":"Deelgemeente",
          "vatTooltip":"Gelieve het BTW-nummer in te vullen zoals het voorbeeld aangeeft.",
          "labelTaal":"Taal",
          "taalTooltop":"De taal waarin u communicatie zult ontvangen."
        },
        "optioneel":"optioneel",
        "labelSubmitButton":"Offerte aanvragen",
        "validation":{
          "afmeting" : "Gelieve een keuze te maken uit de bovenstaande afmetingen a.u.b.",
          "gewicht" : "Gelieve een keuze te maken uit één van beide bovenstaande opties a.u.b.",
          "onderwerp" : "Gelieve een onderwerp in te vullen a.u.b.",
          "companyName" : "Gelieve een bedrijfsnaam in te geven a.u.b.",
          "vat" : "Gelieve een geldig BTW-nummer in te geven a.u.b.",
          "street" : "Gelieve uw straatnaam in te geven a.u.b.",
          "streetNumber" : "Gelieve uw huisnummer in te geven a.u.b.",
          "zipCode" : "Gelieve uw postcode in te geven a.u.b.",
          "city" : "Gelieve uw gemeente in te geven a.u.b.",
          "country" : "Gelieve een land in te geven a.u.b.",
          "lastName" : "Gelieve uw achternaam in te geven a.u.b.",
          "email" : "Gelieve uw e-mailadres in te geven a.u.b.",
          "phoneNr" : "Gelieve uw telefoonnummer in te geven a.u.b.",
          'address' : "U heeft een ongeldig adres ingegeven."
        }
      }
    },
    fr: {
      "intro":"Vous souhaitez lancer une campagne toutes-boîtes? Vous pouvez estimer le budget ci-dessous. Veuillez introduire vos coordonnées ci-dessous et nous vous ferons parvenir un devis sur mesure dans les plus brefs délais. ",
        "loader":"Votre message a été envoyé",
        "form":{
          "firstFieldset":{
            "title" : "1. Spécifications de vos imprimés",
            "labelGewichtFolder":"Poids par dépliant",
            "ofLabel":"ou",
            "labelGrammagePapier":"Grammage du papier",
            "aantalVellen":"Nombre de feuilles par dépliant",
            "labelAfmetingFolder":"Dimensions du dépliant",
            "labelDistributieWeek":"Semaine de distribution",
            "toolTipDistributieWeek":"Vos imprimés peuvent être distribués au plus tôt dans un délai de 2 semaines.",
            "weekMessage":"Votre imprimé fait partie par défaut du paquet de folder. Les consommateurs le reçoivent entre le dimanche matin et le mardi soir. Si vous souhaitez distribuer des imprimés créatifs (tels qu’un accroche-porte, un échantillon, etc.) veuillez contacter.",
            "summerMessage":"Un règlement d'été modifié débutera en juillet et en août. Qu'est-ce que cela implique? Dans un nombre très limité de zones, la fréquence de distribution des paquets de folders est modifiée. Vous pouvez introduire votre demande via ce simulateur et notre service clientèle vous informera rapidement si le règlement d'été adapté concerne la zone que vous avez choisie. Vous trouverez ",
            "summerMessageLabel":"Programme de distribution adapté en été",
            "summerMessagePart2":"un aperçu du planning.",
            "summerMessageHier": "ici",
            "summerMessageLink": "https://www.bdmedia.be/sites/bdmedia.be/files/2023-06/Programme%20d%27%C3%A9t%C3%A9.pdf"
          },
          "secondFieldset":{
            "title":"2. Sélectionnez la zone où vous souhaitez distribuer vos imprimés",
            "intro":"Introduisez ici le(s) code(s) postal(s), la (les) (sous-)commune(s), la (les) province(s) ou la (les) région(s) où vous souhaitez distribuer vos imprimés ou faites votre sélection sur la carte.",
            "buttonToevoegen":"Ajouter",
            "labelSelectie":"Votre sélection",
            "foutmeldingSearch":"Vous devez choisir une valeur parmi les options proposées.",
            "labelPrice":"Estimation du budget",
            "foutmeldingSearchInput":"Veuillez introduire une valeur svp.",
            "toolTipTaal":"Ci-dessous vous trouverez la langue dans laquelle vous devez livrer vos imprimés.",
            "toolTipAantal":"Nombre total des imprimés à distribuer dans votre sélection (nombres nets).",
            "brutoAantallen":"Nombre total de boîtes aux lettres dans votre sélection (nombres bruts).",
            "nettoAantallen":"Nombre total de vos imprimés à distribuer dans votre sélection (nombres nets).",
            "labelTaal":"Langue",
            "labelAantal":"Nombre",
            "labelGemeente":"Commune",
            "labelDeelgemeente":"Sous-municipalité",
            "labelProvincie":"Province",
            "labelProvincies":"Provinces",
          },
          "thirdFieldset":{
            "title":"3. Demandez un devis à BD MEDIA",
            "onderwerp":"Indiquez ici brièvement le sujet de l’imprimé à distribuer.",
            "placeholderDescription":"ex: Dépliant avec promotions sur les appareils électroniques 01/01/2022",
            "labelOnderwerp":"Sujet du dépliant ",
            "labelGegevens":"Vos coordonnées",
            "labelBedrijfsnaam":"Nom de l’entreprise",
            "labelVenootschapsvorm":"Forme juridique",
            "labelVat":"Numéro de TVA",
            "labelStraat":"Rue",
            "labelNummer":"Numéro",
            "labelBus":"Boîte",
            "labelPostcode":"Code postal",
            "labelGemeente":"Commune",
            "labelLand":"Pays",
            "labelVoornaam":"Prénomom",
            "labelAchternaam":"Nom",
            "labelEmail":"Adresse mail",
            "labelTelefoon":"Numéro de téléphone",
            "labelReferentie":"Numéro de référence du client",
            "labelOpmerkingen":"Remarques",
            "labelProvincie":"Provincie",
            "labelDeelgemeente":"Sous-municipalité",
            "vatTooltip":"Veuillez introduire votre numéro de TVA comme dans l’exemple.",
            "labelTaal":"Langue",
            "taalTooltop":"La langue dans laquelle vous recevrez la communication."
          },
          "optioneel":"facultatif",
          "labelSubmitButton":"Demander un devis",
          "validation":{
            "afmeting" : "Veuillez choisir l’une des deux options ci-dessus svp.",
            "gewicht" : "Veuillez choisir l’une des deux options ci-dessus svp.",
            "onderwerp" : "Veuillez introduire un sujet svp.",
            "companyName" : "Veuillez introduire un nom d’entreprise svp.",
            "vat" : "Veuillez introduire votre numéro de TVA comme dans l’exemple.",
            "street" : "Veuillez introduire votre nom de rue svp.",
            "streetNumber" : "Gelieve uw huisnummer in te geven a.u.b.",
            "zipCode" : "Gelieve uw postcode in te geven a.u.b.",
            "city" : "Veuillez introduire votre commune svp.",
            "country" : "Veuillez introduire un pays svp.",
            "lastName" : "Veuillez introduire votre nom svp.",
            "email" : "Veuillez introduire votre adresse mail svp.",
            "phoneNr" : "Veuillez introduire votre numéro de téléphone svp.",
            'address' : "U heeft een ongeldig adres ingegeven."
          }
        }
    }




  }
})
